'use strict';

var _reduce = require('./reduce');

var _reduce2 = _interopRequireDefault(_reduce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var type = require('../value/type');

var flatten = function flatten(input) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;

  if (type(input) === 'array' && depth !== 0) {
    return (0, _reduce2.default)(input, function (list, item) {
      return list.concat(flatten(item, depth - 1));
    }, []);
  }
  return input;
};

module.exports = flatten;


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/iterable/flatten.js
// module id = 1043
// module chunks = 37